import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarGroup } from "@heroui/react";
import type { FarmConfig } from "@/constants/project-specific/farms/types";
import { cn } from "@/util/cn";
import { DoubleLogo } from "@/components/Farm/DoubleLogo";
type Farm = FarmConfig | undefined | null;
export default function PoolLogo(t0) {
  const $ = _c(5);
  const {
    farm
  } = t0;
  const isSinglePool = farm?.tokenB ? false : true;
  cn("p-2");
  if (!isSinglePool) {
    const t1 = farm?.tokenA.logo;
    const t2 = farm?.tokenB?.logo;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
      t3 = <DoubleLogo logo0={t1} logo1={t2} size={50} />;
      $[0] = t1;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  const t1 = farm?.tokenA.logo;
  let t2;
  if ($[3] !== t1) {
    t2 = <DoubleLogo logo0={t1} size={50} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}